import { useEffect, useRef, useState } from "react";

const useInputField = (initailData = {}) => {
   // ################### REACT HOOKS ###################
   const [data, setData] = useState(initailData);
   const focusedInput = useRef(null);
   useEffect(() => {
      focusedInput.current?.focus();
   }, []);

   // ################### HANDLER ###################
   const handleInput = (e) => {
      setData({
         ...data,
         [e.target.name]: e.target.files?.[0] ?? e.target.value.trim(),
      });
   };
   const clearData = () => setData(initailData);

   return [data, focusedInput, handleInput, clearData];
};

export default useInputField;
